@if (!isLoading) {
<div class="insight-container">

  <div class="report-menu">
    <div class="report-title-with-actions">
      <div class="pt-15">
        <button mat-button
                color="accent"
                (click)="goBack()"
        >
          <mat-icon>arrow_back</mat-icon>
          @if (assignment) {
            @if (shift.end) {
              <span class="text-primary">Back to Shift Map</span>
            } @else {
              <span class="text-primary">Back to Live View</span>
            }
          } @else {
            @switch (insightRoute) {
              @case (InsightsRoute.SHIFT_LOOKUP) {
                <span class="text-primary">Back to Shift Lookup</span>
              }
              @case (InsightsRoute.DVIR_REPORT) {
                <span class="text-primary">Back to Inspection Form retrieval</span>
              }
              @case (InsightsRoute.IMAGE_REPORT) {
                <span class="text-primary">Back to Image Retrieval</span>
              }
              @case (InsightsRoute.ADDRESS_LOOKUP) {
                <span class="text-primary">Back to Address Lookup</span>
              }
              @case (InsightsRoute.DEVICE_REPORT) {
                <span class="text-primary">Back to Device Report</span>
              }
              @case (InsightsRoute.SHIFT_DETAIL) {
                <span class="text-primary">Back to Live View</span>
              }
              @case (InsightsRoute.STORM_DETAIL) {
                <span class="text-primary">Back to Storm Detail</span>
              }
              @default {
                <span class="text-primary">Back to Shift Report</span>
              }
            }
          }
        </button>
      </div>

      <div class="report-menu__actions">
        <button
          mat-icon-button
          (click)="closeInsight()"
          [matTooltip]="'Close'"
          aria-label="close address lookup"
          class="report-button"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="shift-map-content">
    <div class="shift-map-left-panel">
      @if (!assignmentId) {
        <app-shift-map-panel
          [configuration]="configuration"
          [shift]="shift"
          [images]="images"
          [observations]="observations"
          [assignments]="assignments"
          class="left__panel"
        ></app-shift-map-panel>
      } @else if (assignmentId > 0 && assignment) {
        <app-assignment-map-panel
          [configuration]="configuration"
          [shift]="shift"
          [assignment]="assignment"
          [images]="images"
          [observations]="observations"
        ></app-assignment-map-panel>
      }
    </div>

    <div class="map-preview-container" #mapContainer>
      @if (!!mapContent) {
        <app-map-preview
          [nextContent]="mapContent"
          [mapTitle]="'Shift Map'"
        >
        </app-map-preview>
      }

      @if (vehicleMarkerFeature) {
        <div class="shift-right-panel">
          <app-breadcrumb-info
            [configuration]="configuration"
            [shift]="shift"
            [vehicleMarkerFeature]="vehicleMarkerFeature"
          ></app-breadcrumb-info>

          @if (hasFeatureFlag(FeatureFlagEnum.DashCam)) {
            @if (images && images.length > 0) {
              <app-image-viewer
                class="image-viewer"
                [images]="images"
                [isLiveMap]="false"
              ></app-image-viewer>
            }
          }
        </div>
      }

      <div class="shift-playback-control">
        @if (shift) {
          <app-time-line-control
            [shiftMapContent]="mapContent"
            [shift]="shift"
            [shiftAssignments]="assignments"
            [assignment]="assignment"
            [shiftTrack]="filteredTrack"
            [time]="vehicleMarkerUnixTime"
            (timeChanged)="onTimeUpdate($event)"
            (speedChanged)="onSpeedUpdate($event)"
          >
          </app-time-line-control>
        }
      </div>
    </div>
  </div>
</div>
}
